import { createTargetLifecycle } from './TargetLifecycle';

/**
 * Builds a Target.
 *
 * The aggregate this constructs is described in `Target.types` — this holds the behaviour and points
 * at it with `@see`.
 *
 * WHY A FACTORY RATHER THAN AN OBJECT LITERAL. The status and its four dates are one concept, and a
 * literal lets a caller set the status and forget a date. Assembling the lifecycle here means every
 * Target has one, and the value object being frozen means it cannot drift afterwards.
 *
 * NOTHING IS DEFAULTED THAT NAMES A DECISION. A target with no status arrives with none: an importer
 * choosing `waiting` for a blank column is making a call, and it should be visible where it is made
 * rather than hidden in a constructor.
 *
 * @see Target.types
 * @param {Object} attrs - flat attributes, as they come off a document or a form
 * @returns {import('./Target.types').Target}
 */
// eslint-disable-next-line import/prefer-default-export
export function createTarget(attrs = {}) {
  return {
    id: attrs.id,
    programId: attrs.programId ?? null,
    parentTargetId: attrs.parentTargetId ?? null,
    label: attrs.label ?? null,
    discriminativeStimulus: attrs.discriminativeStimulus ?? null,
    dataType: attrs.dataType ?? null,
    order: attrs.order,
    lifecycle: createTargetLifecycle({
      status: attrs.status,
      introductionDate: attrs.introductionDate,
      masteryDate: attrs.masteryDate,
      holdDate: attrs.holdDate,
      abortedDate: attrs.abortedDate,
    }),
  };
} // createTarget()
